// src/constants/categories.js
export const categories = [
    {
      category_id: "CM01",
      category_name: "스킨케어",
      questions: [
        {
          question_id: "CM01ff80a28c8af8",
          question_text: "제품 타입",
          options: [
            { option_number: 1, option_text: "토너" },
            { option_number: 2, option_text: "에센스" },
            { option_number: 3, option_text: "세럼" },
            { option_number: 4, option_text: "미스트" },
            { option_number: 5, option_text: "앰플" },
            { option_number: 6, option_text: "크림" },
            { option_number: 7, option_text: "에멀전" },
            { option_number: 8, option_text: "로션" },
            { option_number: 9, option_text: "아이크림" },
            { option_number: 10, option_text: "수분크림" },
            { option_number: 11, option_text: "재생크림" }
          ]
        },
        {
          question_id: "CM012728ff72b9cb",
          question_text: "주요 기능",
          options: [
            { option_number: 1, option_text: "보습" },
            { option_number: 2, option_text: "진정" },
            { option_number: 3, option_text: "미백" },
            { option_number: 4, option_text: "각질제거" },
            { option_number: 5, option_text: "안티에이징" },
            { option_number: 6, option_text: "주름개선" },
            { option_number: 7, option_text: "모공관리" },
            { option_number: 8, option_text: "피지조절" },
            { option_number: 9, option_text: "재생" }
          ]
        },
        {
          question_id: "CM012d96cf9c1c03",
          question_text: "텍스처",
          options: [
            { option_number: 1, option_text: "가벼운" },
            { option_number: 2, option_text: "무거운" },
            { option_number: 3, option_text: "쫀쫀한" },
            { option_number: 4, option_text: "촉촉한" },
            { option_number: 5, option_text: "매트한" },
            { option_number: 6, option_text: "부드러운" }
          ]
        },
        {
          question_id: "CM01aa7b6af271be",
          question_text: "피부 타입 적합성",
          options: [
            { option_number: 1, option_text: "지성" },
            { option_number: 2, option_text: "건성" },
            { option_number: 3, option_text: "복합성" },
            { option_number: 4, option_text: "모든 피부" },
            { option_number: 5, option_text: "수분부족형 지성" }
          ]
        },
        {
          question_id: "CM01f551090673d0",
          question_text: "향",
          options: [
            { option_number: 1, option_text: "플로랄" },
            { option_number: 2, option_text: "프루티" },
            { option_number: 3, option_text: "시트러스" },
            { option_number: 4, option_text: "프레쉬" },
            { option_number: 5, option_text: "그린" },
            { option_number: 6, option_text: "우디" },
            { option_number: 7, option_text: "오리엔탈" },
            { option_number: 8, option_text: "스파이시" },
            { option_number: 9, option_text: "고메" },
            { option_number: 10, option_text: "레더" },
            { option_number: 11, option_text: "파우더" },
            { option_number: 12, option_text: "코튼" },
            { option_number: 13, option_text: "무향" }
          ]
        }
      ]
    },
    {
      category_id: "CM02",
      category_name: "바디케어",
      questions: [
        {
          question_id: "CM02d589ef4dfb71",
          question_text: "종류",
          options: [
            { option_number: 1, option_text: "제모제" },
            { option_number: 2, option_text: "데오드란트" },
            { option_number: 3, option_text: "바디오일" },
            { option_number: 4, option_text: "바디미스트" },
            { option_number: 5, option_text: "샤워젤/바디워시" },
            { option_number: 6, option_text: "바디로션/크림" },
            { option_number: 7, option_text: "핸드/풋 케어" },
            { option_number: 8, option_text: "바디 트리트먼트 마스크/패치" }
          ]
        },
        {
          question_id: "CM02c096d23dfec9",
          question_text: "주요 효과",
          options: [
            { option_number: 1, option_text: "피부결 개선" },
            { option_number: 2, option_text: "탄력 개선" },
            { option_number: 3, option_text: "향기" },
            { option_number: 4, option_text: "보습" },
            { option_number: 5, option_text: "진정" },
            { option_number: 6, option_text: "미백/브라이트닝" },
            { option_number: 7, option_text: "트러블 케어" },
            { option_number: 8, option_text: "모발 제거" }
          ]
        },
        {
          question_id: "CM02e517f01f4efc",
          question_text: "사용 부위",
          options: [
            { option_number: 1, option_text: "전신" },
            { option_number: 2, option_text: "얼굴" },
            { option_number: 3, option_text: "손/발" },
            { option_number: 4, option_text: "특정 바디 부위 (등, 가슴 등)" }
          ]
        },
        {
          question_id: "CM02f551090673d0",
          question_text: "향",
          options: [
            { option_number: 1, option_text: "우디" },
            { option_number: 2, option_text: "머스크" },
            { option_number: 3, option_text: "무향" },
            { option_number: 4, option_text: "플로럴" },
            { option_number: 5, option_text: "시트러스" },
            { option_number: 6, option_text: "프루티" },
            { option_number: 7, option_text: "허브/그린" }
          ]
        },
        {
          question_id: "CM022d96cf9c1c03",
          question_text: "텍스처",
          options: [
            { option_number: 1, option_text: "가벼운" },
            { option_number: 2, option_text: "크리미한" },
            { option_number: 3, option_text: "리치한" }
          ]
        },
        {
          question_id: "CM021e68b64eccad",
          question_text: "특수 기능",
          options: [
            { option_number: 1, option_text: "임산부 안전" },
            { option_number: 2, option_text: "각질 제거" },
            { option_number: 3, option_text: "셀룰라이트 관리" },
            { option_number: 4, option_text: "저자극/민감성 피부용" }
          ]
        },
        {
          question_id: "CM02aa7b6af271be",
          question_text: "피부 타입 적합성",
          options: [
            { option_number: 1, option_text: "모든 피부 타입" },
            { option_number: 2, option_text: "건성" },
            { option_number: 3, option_text: "지성" },
            { option_number: 4, option_text: "복합성" },
            { option_number: 5, option_text: "민감성" }
          ]
        },
        {
          question_id: "CM02bf58ec28b6de",
          question_text: "지속력",
          options: [
            { option_number: 1, option_text: "지속력에 대한 언급 없음" },
            { option_number: 2, option_text: "보통의 지속력" },
            { option_number: 3, option_text: "오랜 지속력" }
          ]
        },
        {
          question_id: "CM02dff167a99814",
          question_text: "천연 성분 비율",
          options: [
            { option_number: 1, option_text: "100% 천연/유기농" },
            { option_number: 2, option_text: "70% 이상" },
            { option_number: 3, option_text: "50% 이상" },
            { option_number: 4, option_text: "30% 이상" },
            { option_number: 5, option_text: "해당 없음/명시되지 않음" }
          ]
        }
      ]
    },
    
    {
      category_id: "CM03",
      category_name: "헤어케어",
      questions: [
        {
          question_id: "CM03d589ef4dfb71",
          question_text: "종류",
          options: [
            { option_number: 1, option_text: "샴푸" },
            { option_number: 2, option_text: "린스" },
            { option_number: 3, option_text: "트리트먼트" },
            { option_number: 4, option_text: "헤어 에센스" },
            { option_number: 5, option_text: "스타일링 제품" },
            { option_number: 6, option_text: "헤어 케어 도구" }
          ]
        },
        {
          question_id: "CM03631b46f8fdb6",
          question_text: "모발 타입 적합성",
          options: [
            { option_number: 1, option_text: "건조모" },
            { option_number: 2, option_text: "지성모" },
            { option_number: 3, option_text: "손상모" },
            { option_number: 4, option_text: "염색모" },
            { option_number: 5, option_text: "민감성 두피" },
            { option_number: 6, option_text: "모든 모발 타입" }
          ]
        },
        {
          question_id: "CM032728ff72b9cb",
          question_text: "주요 기능",
          options: [
            { option_number: 1, option_text: "두피 케어" },
            { option_number: 2, option_text: "보습" },
            { option_number: 3, option_text: "볼륨" },
            { option_number: 4, option_text: "컬 유지" },
            { option_number: 5, option_text: "윤기 부여" },
            { option_number: 6, option_text: "탈모 예방" },
            { option_number: 7, option_text: "손상 복구" },
            { option_number: 8, option_text: "열 보호" }
          ]
        },
        {
          question_id: "CM03f7ccc659d620",
          question_text: "향의 지속력",
          options: [
            { option_number: 1, option_text: "약함" },
            { option_number: 2, option_text: "보통" },
            { option_number: 3, option_text: "강함" },
            { option_number: 4, option_text: "오래 지속" }
          ]
        },
        {
          question_id: "CM03bb32e495ce22",
          question_text: "실리콘 포함 여부",
          options: [
            { option_number: 1, option_text: "실리콘 포함" },
            { option_number: 2, option_text: "실리콘 프리" }
          ]
        },
        {
          question_id: "CM03dff167a99814",
          question_text: "천연 성분 비율",
          options: [
            { option_number: 1, option_text: "100%" },
            { option_number: 2, option_text: "70% 이상" },
            { option_number: 3, option_text: "50% 이상" },
            { option_number: 4, option_text: "30% 이상" }
          ]
        }
      ]
    },
  
    {
      category_id: "CM04",
      category_name: "선케어",
      questions: [
        {
          question_id: "CM0470869aa8b8f5",
          question_text: "타입",
          options: [
            { option_number: 1, option_text: "선크림" },
            { option_number: 2, option_text: "선스틱" },
            { option_number: 3, option_text: "선쿠션" },
            { option_number: 4, option_text: "선스프레이" },
            { option_number: 5, option_text: "선패치" },
            { option_number: 6, option_text: "에프터선 케어" }
          ]
        },
        {
          question_id: "CM0450a2c292a446",
          question_text: "SPF 지수",
          options: [
            { option_number: 1, option_text: "SPF15-30" },
            { option_number: 2, option_text: "SPF30-50" },
            { option_number: 3, option_text: "SPF50+" }
          ]
        },
        {
          question_id: "CM04172bbdc7f22e",
          question_text: "PA 등급",
          options: [
            { option_number: 1, option_text: "PA+" },
            { option_number: 2, option_text: "PA++" },
            { option_number: 3, option_text: "PA+++" },
            { option_number: 4, option_text: "PA++++" }
          ]
        },
        {
          question_id: "CM04157a30308f3e",
          question_text: "백탁 현상",
          options: [
            { option_number: 1, option_text: "있음" },
            { option_number: 2, option_text: "약간 있음" },
            { option_number: 3, option_text: "없음" }
          ]
        },
        {
          question_id: "CM04e517f01f4efc",
          question_text: "사용 부위",
          options: [
            { option_number: 1, option_text: "얼굴용" },
            { option_number: 2, option_text: "바디용" },
            { option_number: 3, option_text: "얼굴/바디 겸용" }
          ]
        },
        {
          question_id: "CM04aa7b6af271be",
          question_text: "피부 타입 적합성",
          options: [
            { option_number: 1, option_text: "지성" },
            { option_number: 2, option_text: "건성" },
            { option_number: 3, option_text: "복합성" },
            { option_number: 4, option_text: "민감성" },
            { option_number: 5, option_text: "모든 피부" }
          ]
        },
        {
          question_id: "CM04ad37156ac0a2",
          question_text: "메이크업 베이스 겸용 가능",
          options: [
            { option_number: 1, option_text: "가능" },
            { option_number: 2, option_text: "불가능" }
          ]
        },
        {
          question_id: "CM04c55d79abfbd5",
          question_text: "부가 기능",
          options: [
            { option_number: 1, option_text: "톤업" },
            { option_number: 2, option_text: "수분 공급" },
            { option_number: 3, option_text: "진정" },
            { option_number: 4, option_text: "미백" },
            { option_number: 5, option_text: "쿨링" },
            { option_number: 6, option_text: "피부 보호" }
          ]
        },
        {
          question_id: "CM047b307e3bedd8",
          question_text: "사용 목적",
          options: [
            { option_number: 1, option_text: "일상적 자외선 차단" },
            { option_number: 2, option_text: "스포츠/아웃도어 활동" },
            { option_number: 3, option_text: "피부 진정" },
            { option_number: 4, option_text: "미백/브라이트닝" }
          ]
        },
        {
          question_id: "CM04b4136e868d72",
          question_text: "특별 기능",
          options: [
            { option_number: 1, option_text: "워터프루프" },
            { option_number: 2, option_text: "쿨링 효과" },
            { option_number: 3, option_text: "땀에 강함" },
            { option_number: 4, option_text: "밀착력" }
          ]
        }
      ]
    },
  
    {
      category_id: "CM05",
      category_name: "클렌징",
      questions: [
        {
          question_id: "CM05f6c6d4267419",
          question_text: "제형",
          options: [
            { option_number: 1, option_text: "폼" },
            { option_number: 2, option_text: "젤" },
            { option_number: 3, option_text: "오일" },
            { option_number: 4, option_text: "밀크" },
            { option_number: 5, option_text: "파우더" },
            { option_number: 6, option_text: "밤" },
            { option_number: 7, option_text: "워터" },
            { option_number: 8, option_text: "티슈" }
          ]
        },
        {
          question_id: "CM0504c09ff1023d",
          question_text: "강도",
          options: [
            { option_number: 1, option_text: "약함" },
            { option_number: 2, option_text: "보통" },
            { option_number: 3, option_text: "강함" }
          ]
        },
        {
          question_id: "CM05f1a7d43087d5",
          question_text: "주요 클렌징 대상",
          options: [
            { option_number: 1, option_text: "메이크업" },
            { option_number: 2, option_text: "블랙헤드" },
            { option_number: 3, option_text: "피지" },
            { option_number: 4, option_text: "미세먼지" }
          ]
        },
        {
          question_id: "CM0549e0cc74da59",
          question_text: "pH 레벨",
          options: [
            { option_number: 1, option_text: "약산성" },
            { option_number: 2, option_text: "중성" },
            { option_number: 3, option_text: "약알칼리성" }
          ]
        },
        {
          question_id: "CM053751497177ac",
          question_text: "특별 성분 포함",
          options: [
            { option_number: 1, option_text: "미네랄" },
            { option_number: 2, option_text: "AHA/BHA" },
            { option_number: 3, option_text: "비타민" },
            { option_number: 4, option_text: "식물 추출물" },
            { option_number: 5, option_text: "자체 개발 성분" }
          ]
        },
        {
          question_id: "CM05e517f01f4efc",
          question_text: "사용 부위",
          options: [
            { option_number: 1, option_text: "전안면" },
            { option_number: 2, option_text: "눈/입술 전용" },
            { option_number: 3, option_text: "바디 겸용" }
          ]
        },
        {
          question_id: "CM053f439831e48a",
          question_text: "헹굼 여부",
          options: [
            { option_number: 1, option_text: "헹굼 필요" },
            { option_number: 2, option_text: "헹굼 불필요" }
          ]
        },
        {
          question_id: "CM05fe1dffec0e5f",
          question_text: "피부 타입",
          options: [
            { option_number: 1, option_text: "민감성" },
            { option_number: 2, option_text: "지성" },
            { option_number: 3, option_text: "모든 피부" }
          ]
        },
        {
          question_id: "CM057e30e56dd9ef",
          question_text: "주요 특징",
          options: [
            { option_number: 1, option_text: "딥 클렌징" },
            { option_number: 2, option_text: "보습" },
            { option_number: 3, option_text: "저자극" },
            { option_number: 4, option_text: "미세먼지 제거" }
          ]
        }
      ]
    },
    {
      category_id: "CM00",
      category_name: "Common",
      questions: [
        {
          question_id: "CM000c7a4d566352",
          question_text: "친환경 패키징 사용",
          options: [
            { option_number: 1, option_text: "재활용 가능 패키징" },
            { option_number: 2, option_text: "생분해성 패키징" },
            { option_number: 3, option_text: "리필제품 제공" },
            { option_number: 4, option_text: "포장 간소화" }
          ]
        },
        {
          question_id: "CM0065ec770282bf",
          question_text: "지속가능한 원료 사용",
          options: [
            { option_number: 1, option_text: "해당 없음" },
            { option_number: 2, option_text: "유기농 원료 사용" },
            { option_number: 3, option_text: "공정무역 원료 사용" },
            { option_number: 4, option_text: "지속가능한 방식으로 재배된 원료 사용" }
          ]
        },
        {
          question_id: "CM00d938d4199166",
          question_text: "환경 보호 캠페인 참여",
          options: [
            { option_number: 1, option_text: "탄소중립 프로그램 참여" },
            { option_number: 2, option_text: "해양 보호 활동 지원" },
            { option_number: 3, option_text: "산림 보호 활동 지원" },
            { option_number: 4, option_text: "기타 환경 보호 활동 참여" }
          ]
        },
        {
          question_id: "CM003d2d7562de23",
          question_text: "제품 구성",
          options: [
            { option_number: 1, option_text: "시리즈" },
            { option_number: 2, option_text: "콤보" },
            { option_number: 3, option_text: "라인" }
          ]
        },
        {
          question_id: "CM00aa7ace476c60",
          question_text: "주요 성분",
          options: []
        },
        // {
        //   question_id: "CM0063d942335227",
        //   question_text: "핵심 기술",
        //   options: []
        // },
        {
          question_id: "CM006e70458d47e6",
          question_text: "비건 여부",
          options: [
            { option_number: 1, option_text: "해당 없음" },
            { option_number: 2, option_text: "비건 원료 사용" }
          ]
        },
        {
          question_id: "CM006d8571c263a3",
          question_text: "주요 인증 그룹",
          options: [
            { option_number: 1, option_text: "품질 및 안전" },
            { option_number: 2, option_text: "피부과학 및 저자극" },
            { option_number: 3, option_text: "국가별 규제 준수" },
            { option_number: 4, option_text: "환경 및 지속가능성" },
            { option_number: 5, option_text: "윤리적 및 동물실험 반대" },
            { option_number: 6, option_text: "유기농 및 천연" }
          ]
        }
      ]
    },
    {
      category_id: "CM99",
      category_name: "Common",
      questions: [
        {
          question_id: "CM99fac1d856cbb9",
          question_text: "제품 컬러",
          options: [
            { option_number: 1, option_text: "빨강" },
            { option_number: 2, option_text: "파랑" },
            { option_number: 3, option_text: "초록" },
            { option_number: 4, option_text: "노랑" },
            { option_number: 5, option_text: "보라" },
            { option_number: 6, option_text: "주황" },
            { option_number: 7, option_text: "분홍" },
            { option_number: 8, option_text: "갈색" },
            { option_number: 9, option_text: "회색" },
            { option_number: 10, option_text: "검정" },
            { option_number: 11, option_text: "흰색" },
            { option_number: 12, option_text: "청록" },
            { option_number: 13, option_text: "자홍" },
            { option_number: 14, option_text: "라임" },
            { option_number: 15, option_text: "틸" },
            { option_number: 16, option_text: "네이비" },
            { option_number: 17, option_text: "적갈색" },
            { option_number: 18, option_text: "올리브" },
            { option_number: 19, option_text: "은색" },
            { option_number: 20, option_text: "금색" },
            { option_number: 21, option_text: "아이보리" }
          ]
        },
        {
          question_id: "CM9973c2786ee2e3",
          question_text: "제품 유형",
          options: [
            { option_number: 1, option_text: "튜브형" },
            { option_number: 2, option_text: "기타" }
          ]
        }
      ]
    }
  ];

  export default categories;